type SectionHeadProps = {
  eyebrow?: string;
  title: string;
  sub?: string;
};

export function SectionHead({ eyebrow, title, sub }: SectionHeadProps) {
  return (
    <div className="section-head">
      {eyebrow && <span className="section-eyebrow">{eyebrow}</span>}
      <h2 className="section-title">{title}</h2>
      {sub && <p className="section-sub">{sub}</p>}
    </div>
  );
}
